import { useParams } from 'react-router-dom';
import { DepartamentosFormState } from '../../../context/departamentos/DepartamentosFormState';
import { Form } from './form';
import useDocumentTitle from '../../../components/Title';

export const DepartamentosFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Departamento" : "Crear Departamento";
  useDocumentTitle(title);

  return (
    <DepartamentosFormState>
        <Form title={title} />
    </DepartamentosFormState>
  );
};